<div style="padding: 20px; position: relative">
  <div style="display: flex; align-items: center; gap: 16px; margin-bottom: 20px; min-width: fit-content; flex-wrap: wrap">
    <mat-form-field style="width: 220px">
      <mat-label>Tyyppi</mat-label>
      <mat-select [value]="valittuKategoriaSubject.value" (selectionChange)="vaihdaKategoriaSuodatin($event.value)">
        @for (suodatin of kategoriaSuodattimet; track suodatin.avain) {
          <mat-option [value]="suodatin.avain">
            {{ suodatin.nimi }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field style="width: 220px">
      <mat-label>Hae tiedostoja...</mat-label>
      <input matInput [formField]="hakuteksti" />
    </mat-form-field>
  </div>

  @if (naytettavatTiedotObservable | async; as tiedot) {
    @if (tiedot.vaihtoehdot.length) {
      <div class="tilikausi-napit-rivi">
        <span class="tilikausi-napit-otsikko">TILIKAUSI</span>
        @for (vaihtoehto of tiedot.vaihtoehdot; track vaihtoehto.avain) {
          <button type="button" class="tilikausi-nappi" [class.tilikausi-nappi-valittu]="valittuTilikausiSubject.value === vaihtoehto.avain" [matTooltip]="vaihtoehto.tooltip" (click)="vaihdaTilikausiSuodatin(vaihtoehto.avain)">
            <span class="tilikausi-nappi-vuosi">{{ vaihtoehto.label }}</span>
            <span class="tilikausi-nappi-maara">{{ vaihtoehto.tiedostojenMaara }} {{ vaihtoehto.tiedostojenMaara === 1 ? 'tiedosto' : 'tiedostoa' }}</span>
          </button>
        }
      </div>
    }

    @if (tiedot.ryhmat.length === 0) {
      <div style="text-align: center; padding: 30px; color: #64748b">Ei tiedostoja.</div>
    }

    @for (ryhma of tiedot.ryhmat; track ryhma.tilikausiAvain) {
      <div class="tilikausi-laatikko">
        @if (ryhma.otsikko) {
          <div class="tilikausi-otsikko">{{ ryhma.otsikko }}</div>
        }
        <div class="table-wrapper">
          <table>
            <thead>
              <tr>
                <th class="center">Lataa</th>
                <th class="center">Esikatsele</th>
                <th class="wide nimi-sarake">Tiedoston nimi</th>
                <th class="wide tyyppi-sarake">Tyyppi</th>
                <th class="wide">Lataaja</th>
                <th class="extra-wide">Lisätiedot</th>
              </tr>
            </thead>
            <tbody>
              @for (file of ryhma.tiedostot; track file.avain) {
                <tr>
                  <td class="center">
                    <app-icon-button matTooltip="Lataa tiedosto koneelle" (click)="downloadFile(file)" actionId="Lataa tiedosto arkistosta koneelle" [actionContext]="[file.avain]">
                      <i class="fa fa-arrow-circle-o-down" style="font-size: 20px"></i>
                    </app-icon-button>
                  </td>
                  <td class="center">
                    @if (file.canPreview && !file.previewOpen) {
                      <app-icon-button matTooltip="Avaa esikatseluun" (click)="previewFile(file)" actionId="Esikatsele tiedosto arkistossa" [actionContext]="[file.avain]">
                        <i class="fa fa-eye" style="font-size: 20px"></i>
                      </app-icon-button>
                    }
                    @if (file.previewOpen) {
                      <app-icon-button matTooltip="Lopeta esikatselu" (click)="stopFilePreview(file)" actionId="Lopeta tiedoston esikatselu arkistossa">
                        <i class="fa fa-eye-slash" style="font-size: 20px"></i>
                      </app-icon-button>
                    }
                  </td>
                  <td class="wide nimi-sarake">
                    <span class="tiedosto-nimi-solu">
                      @if (file.tiedostoIkoni === 'pdf') {
                        <i class="fa fa-file-pdf-o tiedosto-ikoni"></i>
                      }
                      @if (file.tiedostoIkoni === 'kuva') {
                        <i class="fa fa-file-image-o tiedosto-ikoni"></i>
                      }
                      @if (file.tiedostoIkoni === 'taulukko') {
                        <i class="fa fa-file-excel-o tiedosto-ikoni"></i>
                      }
                      @if (file.tiedostoIkoni === 'muu') {
                        <i class="fa fa-file-o tiedosto-ikoni"></i>
                      }
                      <span>{{ file.fileName }}</span>
                    </span>
                  </td>
                  <td class="wide tyyppi-sarake">
                    @if (file.tiedostoTyyppiNimi) {
                      <span class="tyyppi-badge kategoria-{{ file.kategoria }}">
                        {{ file.tiedostoTyyppiNimi }}
                      </span>
                    }
                    @if (!file.tiedostoTyyppiNimi) {
                      <span>–</span>
                    }
                  </td>
                  <td class="wide">{{ file.lataajaName }}</td>
                  <td class="extra-wide">{{ file.lisatiedot }}</td>
                </tr>
                @if (file.previewOpen) {
                  <tr>
                    <td colspan="6">
                      @if (file.previewLoading) {
                        <div style="margin: 20px; text-align: center">
                          Esikatselua ladataan...
                          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                        </div>
                      } @else {
                        @if (file.previewType === 'pdf') {
                          <div app-pdf-viewer [url]="file.previewFileDataUrl | async"></div>
                        }
                        @if (file.previewType === 'jpg' || file.previewType === 'png') {
                          <div app-image-zoom [thumbImage]="file.previewFileDataUrl | async"></div>
                        }
                      }
                    </td>
                  </tr>
                }
              }
            </tbody>
          </table>
        </div>
      </div>
    }
  }
</div>
